// Sharun Store operates as one platform across several poddomains, each
// dedicated to a lifestyle section. These helpers resolve a product or
// real-estate object's "canonical" full-page URL to the poddomain that owns
// its section, so a link opened from anywhere on the platform lands on the
// right site — matching the domain split rolled out in Этап 2.
export const SUBDOMAINS = {
  style: 'https://moda.sharun.store',
  space: 'https://home.sharun.store',
  drive: 'https://auto.sharun.store',
  realty: 'https://realty.sharun.store',
} as const

// Root product-taxonomy ids — see GET /api/taxonomies/tree. Style and Space
// are the only two root categories products currently live under; there is
// no taxonomy root for Drive (vehicles use a separate, unrelated API and
// aren't routed through this yet).
const STYLE_ROOT_TAXONOMY_ID = 1
const SPACE_ROOT_TAXONOMY_ID = 5

export interface ProductForLink {
  id: number | string
  tree?: Array<{ id: number }>
}

/**
 * Full product/service page URL, routed to the poddomain matching the
 * product's root category. Falls back to a same-site relative path when the
 * root category is unknown (e.g. list endpoints that don't return `tree`).
 */
export function productPageUrl(product: ProductForLink): string {
  const rootId = product.tree?.[0]?.id
  if (rootId === STYLE_ROOT_TAXONOMY_ID) return `${SUBDOMAINS.style}/product/${product.id}`
  if (rootId === SPACE_ROOT_TAXONOMY_ID) return `${SUBDOMAINS.space}/product/${product.id}`
  return `/product/${product.id}`
}

/** Real-estate objects always live under realty.sharun.store. */
export function realtyObjectPageUrl(id: number | string): string {
  return `${SUBDOMAINS.realty}/real-estate/${id}`
}
